/**
 * @flow
 * @relayHash 9b58681a570f07e2f51a09055d6feba9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GiftcardCard_viewer$ref = any;
export type GiftcardCardQueryRendererQueryVariables = {|
  eventId: string
|};
export type GiftcardCardQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: GiftcardCard_viewer$ref
  |}
|};
export type GiftcardCardQueryRendererQuery = {|
  variables: GiftcardCardQueryRendererQueryVariables,
  response: GiftcardCardQueryRendererQueryResponse,
|};
*/


/*
query GiftcardCardQueryRendererQuery(
  $eventId: ID!
) {
  viewer {
    ...GiftcardCard_viewer
    id
  }
}

fragment GiftcardCard_viewer on Viewer {
  account {
    eventPurchases(byStartnumber: true, eventId: $eventId) {
      giftcards {
        code
        initialValue
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GiftcardCardQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GiftcardCard_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GiftcardCardQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "account",
            "storageKey": null,
            "args": null,
            "concreteType": "Account",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "eventPurchases",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "byStartnumber",
                    "value": true
                  },
                  {
                    "kind": "Variable",
                    "name": "eventId",
                    "variableName": "eventId"
                  }
                ],
                "concreteType": "EventPurchases",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "giftcards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Giftcard",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "initialValue",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GiftcardCardQueryRendererQuery",
    "id": null,
    "text": "query GiftcardCardQueryRendererQuery(\n  $eventId: ID!\n) {\n  viewer {\n    ...GiftcardCard_viewer\n    id\n  }\n}\n\nfragment GiftcardCard_viewer on Viewer {\n  account {\n    eventPurchases(byStartnumber: true, eventId: $eventId) {\n      giftcards {\n        code\n        initialValue\n      }\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd23525b2365788526123b4be6bc822bb';

module.exports = node;
